module.exports = __webpack_public_path__ + "static/media/scanning-run-back.b8aa87dd.png";